// removed by extract-text-webpack-plugin
module.exports = {"Label":"DeliveryType__Label__rFdrd","DeliveryType":"DeliveryType__DeliveryType__2rtZZ","Inline":"DeliveryType__Inline__180xM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Order/DeliveryType/DeliveryType.css
// module id = 199
// module chunks = 1